import React, { useEffect, useRef, useState } from "react";
import CustomGrid from "../../../components/CustomComponents/CustomGrid/CustomGrid";
import { useStyles } from "../../../assets/jss/AdminUser";
import CustomBox from "../../../components/CustomComponents/CustomBox/CustomBox";
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import CustomPaper from "../../../components/CustomComponents/CustomPaper/CustomPaper";
import CustomTypography from "../../../components/CustomComponents/CustomTypography/CustomTypography";
import CustomTextField from "../../../components/CustomComponents/CustomTextField/CustomTextField";
import CustomFormControlLabel from "../../../components/CustomComponents/CustomFormControlLabel/CustomFormControlLabel";
import CustomSelect from "../../../components/CustomComponents/CustomSelect/CustomSelect";
import CustomMenuItem from "../../../components/CustomComponents/CustomMenuItem/CustomMenuItem";
import CustomInputLabel from "../../../components/CustomComponents/CustomInputLabel/CustomInputLabel";
import CustomFormControl from "../../../components/CustomComponents/CustomFormControl/CustomFormControl";
import CustomCheckbox from "../../../components/CustomComponents/CustomCheckbox/CustomCheckbox";
import CustomButton from "../../../components/CustomComponents/CustomButton/CustomButton";
import { useHistory } from "react-router-dom";
import backButton from "../../../assets/images/back_button.svg";
import plugIcon from "../../../assets/images/plug.svg";
import lock from "../../../assets/images/lock.png";
import clsx from "clsx";
import GroupHierarchy from "../../../components/GroupHierarchy/GroupHierarchy";
import {
    adminGetUser,
    adminGetUserRole,
    adminUpsertUser,
} from "../../../services/AdminUserService";
import ErrorAlert from "../../../components/ErrorAlert/ErrorAlert";
import CustomDivider from "../../../components/CustomComponents/CustomDivider/CustomDivider";
import CustomList from "../../../components/CustomComponents/CustomList/CustomList";
import CustomListItem from "../../../components/CustomComponents/CustomListItem/CustomListItem";
import DateTime from "../../../components/DateTime/DateTime";
import {
    CustomRadio,
    CustomRadioGroup,
} from "../../../components/CustomComponents/CustomRadio/CustomRadio";
import {
    CrudAction,
    ContentStatus,
    RecordStatus,
    Role,
    RBAC_CODE,
    EntityAccess,
    IsAnonymize,
    IsUserAccountLocked,
    UserLicenseView
} from "../../../config/app-globals.enum";
import {
    getSession,
    getUserData,
    getUserRBAC,
    getIsAllowDeleteDriver,
    getIsAllowAddDriver,
    getLicenseAddStatus,
    getLicenseExpireSoonPeriod
} from "../../../services/LocalStorageService";
import DeleteUserDialog from "../../../components/Dialogs/DeleteUser/DeleteUser";
import { doForgotPassword } from "../../../services/ForgottenPassword";
import CustomCircularProgress from "../../../components/CustomComponents/CustomCircularProgress/CustomCircularProgress";
import { useTranslation, Trans } from "react-i18next";
import { useMediaQuery, useTheme } from "@material-ui/core";
// import { getCurrentGroupPreference } from "../../../services/LocalStorageService";
import UnlockUserDialog from "../../../components/Dialogs/ConfirmAction/UnlockUser";
import AddIcon from '@material-ui/icons/Add';
import LicenseDetailsDialog from "../../../components/Dialogs/LicenseDetails/LicenseDetails";
import { dateDiffInDays } from "../../../config/app-global-method";
import { GetUserLicenseAPI } from "../../../services/LicenseCheckService";

export default function User(props: any) {
    // const [groupPreference] = useState(JSON.parse(getCurrentGroupPreference()));
    const { t } = useTranslation();
    const theme = useTheme();
    const isIpadPortraitDown = useMediaQuery(theme.breakpoints.down("sm"));
    const classes = useStyles();
    const [getRBAC_AdminUserView] = React.useState(
        getUserRBAC(RBAC_CODE.ADMIN_USER_VIEW, props)
    );
    const [getRBAC_AdminUserCreateView] = React.useState(
        getUserRBAC(RBAC_CODE.ADMIN_USER_CREATE_VIEW, props)
    );
    const [getRBAC_AdminUserEditView] = React.useState(
        getUserRBAC(RBAC_CODE.ADMIN_USER_EDIT_VIEW, props)
    );
    const [getRBAC_AdminUserDeleteView] = React.useState(
        getUserRBAC(RBAC_CODE.ADMIN_USER_DELETE_VIEW, props)
    );
    const history = useHistory();
    const [loggedInUserSession] = useState(getSession);
    const [loggedInUserData] = useState<any>(getUserData);
    const [userId, setUserId] = useState();
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [unlockDialogOpen, setUnlockDialogOpen] = useState(false);
    const [accountLocked, setAccountLocked] = useState(0);
    // const [groupList, setGroupList] = useState(null);
    const [isAddingDriverAllowed, setIsAddingDriverAllowed] = useState(false);
    // const [licenseNumber, setLicenseNumber] = useState('');
    const [isAllowDeleteDriver, setIsAllowDeleteDriver] = useState(false);
    const [licenseDialogOpen, setLicenseDialogOpen] = useState(false);
    const [userData, setUserData] = useState({
        id: "",
        firstName: "",
        middleName: "",
        lastName: "",
        email: "",
        nickName: "",
        userRoleId: 0,
        userRoleObj: [],
        userRoles: [],
        contentStatus: 0,
        status: 0,
        recordStatus: 1,
        currentGroupId: "",
        userGroupId: "",
        createdOn: new Date(),
        allowChangesToGroupOrgChart: 0,
        isAnonymize: 0,
        isUserNameEditable: 0,
        isAccountLocked: 0,
        providerUserInfo: {
            providerUserNo: "",
            providerUserUid: "",
            providerId: "",
        }
    });
    const [licenseData, setLicenseData] = useState({
        id: "",
        licenseList: []
    });
    const [isDriver, setIsDriver] = useState(false);
    const [userFormValidation, setUserFormValidation] = useState({
        firstName: {
            isRequired: true,
            isValid: true,
            validationMessage: "",
            pattern:
                "^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-]+)*$",
        },
        lastName: {
            isRequired: true,
            isValid: true,
            validationMessage: "",
            pattern:
                "^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-]+)*$",
        },
        nickName: {
            isRequired: userData.isAnonymize === IsAnonymize.YES && userData.userRoleId === Role.DRIVER ? true : false,
            isValid: userData.isAnonymize === IsAnonymize.YES && userData.userRoleId === Role.DRIVER ? true : false,
            validationMessage: "",
            pattern:
                "^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-]+)*$",
        },
        email: {
            isRequired: true,
            isValid: true,
            validationMessage: "",
            pattern:
                "^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-]+)*$",
        },
    });
    const [groupHierarchyData, setGroupHierarchyData] = useState<any>(null);
    const [groupHierarchyFlatData, setGroupHierarchyFlatData] = useState<any>(null);
    const [isUserRoleObj, setIsUserRoleObj] = useState(false);
    const [selectedGroup, setSelectedGroup] = useState<any>(null);
    const [defaultExpandedArray, setDefaultExpandedArray] = useState([]);
    const [userViewAction, setUserViewAction] = React.useState();
    const [crudAction, setCrudAction] = React.useState(0);
    const [isFormValid, setIsFormValid] = React.useState(false);
    const [isFormSubmit, setIsFormSubmit] = React.useState(false);
    const [isNameEdit, setIsNameEdit] = useState(true);
    const [isLicenseAdd] = useState(getLicenseAddStatus());
    const [licenseExpireSoonPeriod] = useState(getLicenseExpireSoonPeriod());
    const [fnamePosition, setFnamePosition] = useState(0);
    const [lnamePosition, setLnamePosition] = useState(0);
    const [emailPosition, setEmailPosition] = useState(0);
    const [nickNamePosition, setNickNamePosition] = useState(0);

    useEffect(() => {
        if (isFormSubmit) {
            const fnameRect = document.getElementById("fname").getBoundingClientRect();
            const lnameRect = document.getElementById("lname").getBoundingClientRect();
            const emailRect = document.getElementById("email").getBoundingClientRect();
            setFnamePosition(fnameRect.y);
            setLnamePosition(lnameRect.y);
            setEmailPosition(emailRect.y);
            const nickNameField = document.getElementById("nickName");
            if (nickNameField) {
                const nickNameRect = nickNameField.getBoundingClientRect();
                if (nickNameRect) {
                    setNickNamePosition(nickNameRect.y);
                }
            }
        }

    }, [isFormSubmit]);

    const setFocus = useRef(true);

    useEffect(() => {
        if (loggedInUserSession) {
            if (userViewAction === CrudAction.ADD) {
                setSelectedGroup(loggedInUserSession.currentGroupId);
                setUserData({
                    ...userData,
                    userGroupId: loggedInUserSession.currentGroupId,
                });
            }
        }
    }, [loggedInUserSession, userViewAction]);

    const [isUserRoleApiFailed, setIsUserRoleApiFailed] = useState(false);
    const [isUserRoleApi, setIsUserRoleApi] = useState(false);
    const [userRoleStatusValue, setUserRoleStatusValue] = React.useState<any>("");
    const [userRoleAlertMessage, setUserRoleAlertMessage] = React.useState("");
    const [isUserRoleAlertOpen, setIsUserRoleAlertOpen] = React.useState(false);
    const [userRole, setUserRole] = useState<any>(null);

    const changeUserRoleApiStatusCodeFunc = (status) => {
        if (status.code && status.code !== 0 && status.code !== 200) {
            setUserRoleStatusValue(status.code);
            setUserRoleAlertMessage(
                status.message
                    ? status.message
                    : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`
            );
            setIsUserRoleAlertOpen(true);
        }
    };

    useEffect(() => {
        setUserViewAction(props.userViewAction);
        setCrudAction(props.userViewAction);
        async function getUserRoles() {

            setUserRoleStatusValue("");
            setIsUserRoleApi(true);
            setUserRoleAlertMessage("");
            setIsUserRoleAlertOpen(false);
            const data = await adminGetUserRole();
            if (
                data &&
                (data.status.code === 0 ||
                    data.status.code === 200 ||
                    data.status.code === 201) &&
                data.content
            ) {
                setIsUserRoleApi(false);
                setIsUserRoleApiFailed(false);
                setUserRole(data.content);
            } else {
                setIsUserRoleApi(false);
                setIsUserRoleApiFailed(true);
                changeUserRoleApiStatusCodeFunc(data.status);
            }
        }
        if (!userRole) {
            getUserRoles();
        }

        if (props && props.match.params.userId && !userId) {
            setUserId(props.match.params.userId);
        }
    }, [props]);

    const [isGetUserApiFailed, setIsGetUserApiFailed] = useState(false);
    const [isGetUserApi, setIsGetUserApi] = useState(false);
    const [getUserStatusValue, setGetUserStatusValue] = React.useState<any>();
    const [getUserAlertMessage, setGetUserAlertMessage] = React.useState("");
    const [isGetUserAlertOpen, setIsGetUserAlertOpen] = React.useState(false);


    const changeGetUserApiStatusCodeFunc = (status) => {
        if (status.code && status.code !== 0 && status.code !== 200) {
            setGetUserStatusValue(status.code);
            setGetUserAlertMessage(
                status.message
                    ? status.message
                    : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`
            );
            setIsGetUserAlertOpen(true);
        }
    };

    async function getUserDataFromServer() {
        setGetUserStatusValue(0);
        setIsGetUserApi(true);
        setGetUserAlertMessage("");
        setIsGetUserAlertOpen(false);
        const data = await adminGetUser(userId);
        if (
            data &&
            (data.status.code === 0 ||
                data.status.code === 200 ||
                data.status.code === 201) &&
            data.content
        ) {
            setIsGetUserApi(false);
            setIsGetUserApiFailed(false);
            setUserData(data.content);
            setIsAllowDeleteDriver(getIsAllowDeleteDriver(data.content.userGroupId));
            setAccountLocked(data.content.isAccountLocked);
            if (data.content.isUserNameEditable === 1) {
                setIsNameEdit(true);
            } else {
                let driver = data.content.userRoles.find(el => el === Role.DRIVER);
                if (driver === undefined || driver === null) {
                    setIsNameEdit(true);
                } else {
                    setIsNameEdit(false);
                }
            }
        } else {
            setIsGetUserApi(false);
            setIsGetUserApiFailed(true);
            changeGetUserApiStatusCodeFunc(data.status);
        }
    }

    useEffect(() => {
        try {
            if (userId) {
                getUserDataFromServer();
            }
        } catch (error) {
            console.log('error while fetching user/license data');
        }
    }, [userId]);

    const handleGroupChange = (event) => {
        if (
            userViewAction === CrudAction.ADD ||
            userViewAction === CrudAction.EDIT
        ) {
            setSelectedGroup(event.target.value);
            setUserData({ ...userData, userGroupId: event.target.value });
        }
    };


    const handleUserRoleChange = (event, index, roleId) => {
        if (userData && userData.userRoleObj && userData.userRoleObj.length) {
            const _userRoleObj = [...userData.userRoleObj];
            const _role = [...userData.userRoles];
            _userRoleObj[index]["isSelected"] = event.target.checked;
            if (_role && _role.length) {
                const roleIndex = _role.findIndex((id) => id === roleId);
                if (roleIndex >= 0) {
                    _role.splice(roleIndex, 1);
                }
            }
            if (event.target.checked) {
                _role.push(roleId);
            }
            if (userViewAction === CrudAction.ADD) {
                if (roleId === Role.DRIVER && _userRoleObj[index].isSelected) {
                    setUserData({
                        ...userData,
                        status: ContentStatus.ACTIVE,
                        userRoles: [..._role],
                        userRoleObj: [..._userRoleObj],
                    });
                } else {
                    setUserData({
                        ...userData,
                        status: ContentStatus.ONHOLD,
                        userRoles: [..._role],
                        userRoleObj: [..._userRoleObj],
                    });
                }
            } else {
                setUserData({
                    ...userData,
                    userRoles: [..._role],
                    userRoleObj: [..._userRoleObj],
                });
            }
        }
    };

    useEffect(() => {
        if (userData !== null && userData !== undefined && userRole !== null && userRole !== undefined && userRole.length && (!Array.isArray(userData.userRoleObj) || userData.userRoleObj.length === 0)) {
            const newUserRole = [];
            for (let i = 0; i < userRole.length; i++) {
                const currentUserRole = { ...userRole[i] };
                currentUserRole.isSelected = false;
                currentUserRole.isEnabled = true;
                /** @todo: need to correct if role is enabled at admin side or not */
                if (userRole[i].name === "DRIVER") {
                    currentUserRole.isEnabled = false;
                }
                if (userData.userRoles && userData.userRoles.length) {
                    const currentUserRoleIndex = userData.userRoles.find(
                        (role) => role === userRole[i].id
                    );
                    if (currentUserRoleIndex && currentUserRoleIndex >= 0) {
                        currentUserRole.isSelected = true;
                    }
                }
                newUserRole.push(currentUserRole);
            }
            setUserData({
                ...userData,
                userRoleObj: [...newUserRole],
            });
            //setUserRoleObj([...newUserRole]);
            setIsUserRoleObj(true);
        }
    }, [userData, userRole]);

    /* const setUserRoleObj = useCallback((data:any) => {
        setUserData({
            ...userData,
            userRoleObj: [...data],
        });
    }, [userData.userRoleObj]); */

    useEffect(() => {
        let groupArray = [];
        if (groupHierarchyData) {
            // let flatObj = [];
            // const flatten = (obj, prefix = [], current = {}) => {
            //   if (typeof obj === "object" && obj !== null) {
            //     if (obj && !obj.length) {
            //       flatObj.push({ ...obj });
            //     }
            //     for (const key of Object.keys(obj)) {
            //       flatten(obj[key], prefix.concat(key), current);
            //     }
            //   } else {
            //     current[prefix.join(".")] = obj;
            //   }
            //   return current;
            // };
            // const flatGroup = flatten(groupHierarchyData);
            // if (flatObj && flatObj.length) {
            //   flatObj.sort((obj1, obj2) => parseInt(obj1.id) - parseInt(obj2.id));
            // }
            insertGroup(groupHierarchyData, null);
            setGroupHierarchyFlatData([...groupArray]);
        }


        function insertGroupInArray(group: any, parentGroupId: any) {
            const _group = { ...group };
            _group["parentGroupId"] = parentGroupId;
            delete _group.childGroups;
            groupArray.push({ ..._group });
        }
        function insertGroup(group: any, parentGroupId: any) {
            const _group = { ...group };
            insertGroupInArray(_group, parentGroupId);
            if (_group.childGroups && _group.childGroups.length) {
                itirateGroup(_group.childGroups, _group.id);
            }
        }
        function itirateGroup(childGroups: any, parentGroupId: any) {
            if (childGroups && childGroups.length) {
                for (const group of childGroups) {
                    const _group = { ...group };
                    insertGroupInArray(_group, parentGroupId);
                    if (_group.childGroups && _group.childGroups.length) {
                        itirateGroup([..._group.childGroups], _group.id);
                    }
                }
            }
        }

    }, [groupHierarchyData]);

    useEffect(() => {
        if (userData && userData.userGroupId) {
            setSelectedGroup(userData.userGroupId);
        }
        if (
            userData.userRoles &&
            userData.userRoles.length &&
            userData.userRoles.find((id) => id === Role.DRIVER)
        ) {
            if (!isAddingDriverAllowed) {
                setIsDriver(true);
            }
        }
        if (userViewAction !== CrudAction.ADD && isLicenseAdd && userData.userRoleObj === undefined) {
            getLicenseData();
        }
    }, [userData]);

    const [isUpsertUserApiFailed, setIsUpsertUserApiFailed] = useState(false);
    const [isUpsertUserApi, setIsUpsertUserApi] = useState(false);
    const [upsertUserStatusValue, setUpsertUserStatusValue] = React.useState("");
    const [upsertUserAlertMessage, setUpsertUserAlertMessage] = React.useState("");
    const [upsertUserAlertDescription, setUpsertUserAlertDescription] = useState("");
    const [upsertUserAlertType, setUpsertUserAlertType] = useState("error");
    const [isUpsertUserAlertOpen, setIsUpsertUserAlertOpen] =
        React.useState(false);
    const changeUpsertUserApiStatusCodeFunc = (status, userId = null, userRecordStatus?: any) => {
        setUpsertUserStatusValue(status.code);
        if (status.code === 0 || status.code === 200 || status.code === 201) {
            //setUpsertUserAlertMessage(status.message ? status.message : t("SUCCESS"));
            setUpsertUserAlertType("success");
            let userDescription = "";
            if (crudAction === CrudAction.ADD) {
                userDescription = t("USER_HAS_BEEN_ADDED_SUCCESSFULLY");
            } else if (crudAction === CrudAction.EDIT) {
                if (userRecordStatus === RecordStatus.DELETE) {
                    userDescription = t("USER_HAS_BEEN_DELETED_SUCCESSFULLY");
                } else {
                    userDescription = t("USER_HAS_BEEN_UPDATED_SUCCESSFULLY");
                }
            } else if (crudAction === CrudAction.DELETE || userRecordStatus === RecordStatus.DELETE) {
                userDescription = t("USER_HAS_BEEN_DELETED_SUCCESSFULLY");
            }
            setUpsertUserAlertMessage(userDescription);
        } else {
            setUpsertUserAlertMessage(
                status.message
                    ? status.message
                    : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`
            );
            setUpsertUserAlertType("error");
            let userDescription = "";
            if (crudAction === CrudAction.ADD) {
                if (status.code === 1008) {
                    userDescription = `<Trans i18nKey="CLICK_HERE_TO_VISIT_USER_DETAIL">
                    Click <a href="/admin/users/${userId}">here</a> to visit user's detail
                    </Trans>`;
                } else {
                    userDescription = t("FAILED_TO_CREATE_USER");
                }
            } else if (crudAction === CrudAction.EDIT) {
                userDescription = t("FAILED_TO_UPDATE_USER");
            } else if (crudAction === CrudAction.DELETE) {
                userDescription = t("FAILED_TO_DELETE_USER");
            }
            setUpsertUserAlertDescription(userDescription);
        }
        setIsUpsertUserAlertOpen(true);
    };

    async function upsertUserData(userData) {
        let userRecordStatus = userData.recordStatus;
        if (userData?.userRoles && userData.userRoles.find((id) => id === Role.DRIVER) && groupHierarchyData !== undefined && groupHierarchyData !== null && groupHierarchyData.providerId !== undefined && groupHierarchyData.providerId !== null) {
            let providerInfo = { ...userData.providerUserInfo, providerId: groupHierarchyData.providerId };
            const finalUserData = { ...userData, providerUserInfo: providerInfo };
            userData = finalUserData;
        }
        const _userDataTrimmed = { ...userData };
        if (_userDataTrimmed?.userRoleObj)
            delete _userDataTrimmed.userRoleObj;
        if (_userDataTrimmed?.userRoleId)
            delete _userDataTrimmed.userRoleId;
        if (_userDataTrimmed?.userRoles) {
            const _trimmedUserRole = _userDataTrimmed.userRoles.filter((n) => n);
            _userDataTrimmed.userRoles = [..._trimmedUserRole];
        }
        setUpsertUserStatusValue("");
        setIsUpsertUserApi(true);
        setUpsertUserAlertMessage("");
        setIsUpsertUserAlertOpen(false);
        const data = await adminUpsertUser(_userDataTrimmed);
        if (
            data &&
            (data.status.code === 0 ||
                data.status.code === 200 ||
                data.status.code === 201) &&
            data.content
        ) {
            setIsUpsertUserApi(false);
            setIsUpsertUserApiFailed(false);
            if (Number(userRecordStatus) === RecordStatus.DELETE) {
                changeUpsertUserApiStatusCodeFunc(data.status, null, userRecordStatus)
            } else {
                changeUpsertUserApiStatusCodeFunc(data.status)
            }
            setIsFormSubmit(false);
            setIsFormValid(true);
            setTimeout(function () {
                if (userRecordStatus === RecordStatus.DELETE) {
                    history.replace(`/admin/users`);
                } else {
                    history.replace(`/admin/users/${data.content.id}`);
                }
            }, 1500);
        } else {
            setIsUpsertUserApi(false);
            setIsUpsertUserApiFailed(true);
            changeUpsertUserApiStatusCodeFunc(
                data.status,
                data.content &&
                    data.content.registeredUser &&
                    data.content.registeredUser.id
                    ? data.content.registeredUser.id
                    : null
            );
            setIsFormSubmit(false);
            setIsFormValid(true);
        }
    }

    useEffect(() => {
        if (isFormSubmit && isFormValid) {
            upsertUserData(userData);
        }
    }, [isFormSubmit, isFormValid]);

    const verifyUserInput = (userForm) => {
        setIsFormSubmit(false);
        setIsFormValid(true);
        setFocus.current = true;
        if (userForm) {
            let _userFormValidation = { ...userFormValidation };
            for (const [key, value] of Object.entries(userFormValidation)) {
                const _value = { ...value };
                const currentValue = userForm[key];
                if (_value && _value.isRequired) {
                    if (!currentValue || !currentValue.length || currentValue === null) {
                        _value.isValid = false;
                        _value.validationMessage = t("THIS_FIELD_CAN_NOT_BE_EMPTY");
                        setIsFormValid(false);
                    } else {
                        _value.isValid = true;
                        _value.validationMessage = "";
                        if (key === "firstName") {
                            if (currentValue.trim().length < 2) {
                                _value.isValid = false;
                                _value.validationMessage = t(
                                    "FIRST_NAME_SHOULD_BE_GREATER_THAN_TWO_CHARACTERS"
                                );
                                setIsFormValid(false);
                            }
                        } else if (key === "lastName") {
                            if (currentValue.trim().length < 2) {
                                _value.isValid = false;
                                _value.validationMessage = t(
                                    "LAST_NAME_SHOULD_BE_GREATER_THAN_TWO_CHARACTERS"
                                );
                                setIsFormValid(false);
                            }
                        } else if (key === "email") {
                            if (currentValue.trim().match(_value.pattern) === null) {
                                _value.isValid = false;
                                _value.validationMessage = t(
                                    "LOOKS_LIKE_YOU_HAVE_ENTERED_INVALID_EMAIL"
                                );
                                setIsFormValid(false);
                            }
                        }
                    }
                }
                _userFormValidation[key] = { ..._value };
            }
            setUserFormValidation({
                ..._userFormValidation,
            });
            setIsFormSubmit(true);
        }
        return isFormValid;
    };

    const changeContentStatus = (e) => {
        setUserData({
            ...userData,
            status: parseInt(e.target.value),
        });
    };

    const deleteUserDialogFunc = (isOpen, confirmDelete) => {
        setDeleteDialogOpen(isOpen);
        if (confirmDelete) {
            const deleteUserObj = {
                id: userData.id,
                recordStatus: RecordStatus.DELETE,
            };
            setCrudAction(CrudAction.DELETE);
            setUserData({
                ...userData,
                ...deleteUserObj,
            });
            //verifyUserInput(userData);
            upsertUserData(deleteUserObj);
        }
    };



    const unlockUserDialogFunc = (isOpen, confirmUnlock) => {
        setUnlockDialogOpen(isOpen);
        if (confirmUnlock) {
            const unlockUserObj = {
                id: userData.id,
                isAccountLocked: accountLocked === IsUserAccountLocked.LOCKED ? IsUserAccountLocked.UNLOCKED : IsUserAccountLocked.LOCKED
            };
            setUserData({
                ...userData,
                ...unlockUserObj,
            });
            //verifyUserInput(userData);
            upsertUserData(unlockUserObj);
        }
    };

    const [isResetPasswordApiFailed, setIsResetPasswordApiFailed] = useState(false);
    const [isResetPasswordApi, setIsResetPasswordApi] = useState(false);
    const [resetPasswordStatusValue, setResetPasswordStatusValue] =
        React.useState("");
    const [resetPasswordAlertMessage, setResetPasswordAlertMessage] =
        React.useState("");
    const [isResetPasswordAlertOpen, setIsResetPasswordAlertOpen] =
        React.useState(false);
    const [resetPasswordAlertDescription, setResetPasswordAlertDescription] =
        useState("");
    const [resetPasswordAlertType, setResetPasswordAlertType] = useState("error");
    const changeResetPasswordApiStatusCodeFunc = (status) => {
        setResetPasswordStatusValue(status.code);
        if (status.code === 0 || status.code === 200 || status.code === 201) {
            setResetPasswordAlertMessage(
                status.message ? status.message : t("SUCCESS")
            );
            setResetPasswordAlertType("success");
            setResetPasswordAlertDescription(
                t("RESET_PASSWORD_LINK_HAS_BEEN_SENT_TO_THE_USERS_REGISTERED_EMAIL")
            );
        } else {
            setResetPasswordAlertMessage(
                status.message
                    ? status.message
                    : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`
            );
            setResetPasswordAlertType("error");
            setResetPasswordAlertDescription(
                t("FAILED_TO_SEND_RESET_PASSWORD_LINK_TO_THE_USER")
            );
        }
        setIsResetPasswordAlertOpen(true);
    };

    const resetPasswordFunc = (email) => {
        async function resetPassword(email) {
            setResetPasswordStatusValue(null);
            setIsResetPasswordApi(true);
            setResetPasswordAlertMessage("");
            setIsResetPasswordAlertOpen(false);
            const data = await doForgotPassword(email);
            if (
                data &&
                (data.status.code === 0 ||
                    data.status.code === 200 ||
                    data.status.code === 201) &&
                data.content
            ) {
                setIsResetPasswordApi(false);
                setIsResetPasswordApiFailed(false);
                changeResetPasswordApiStatusCodeFunc(data.status);
            } else {
                setIsResetPasswordApi(false);
                setIsResetPasswordApiFailed(true);
                changeResetPasswordApiStatusCodeFunc(data.status);
            }
        }
        resetPassword(email);
    };

    useEffect(() => {
        const expandedNodeId = [];
        if (
            selectedGroup &&
            groupHierarchyFlatData &&
            groupHierarchyFlatData.length
        ) {
            getGroupId(groupHierarchyFlatData, selectedGroup);
            if (expandedNodeId && expandedNodeId.length) {
                setDefaultExpandedArray([...expandedNodeId]);
            }
            if (groupHierarchyFlatData && groupHierarchyFlatData.length) {
                var obj = groupHierarchyFlatData.find(({ id }) => id === selectedGroup);
                if (obj !== undefined && obj !== null) {
                    const isAllow = getIsAllowAddDriver(selectedGroup);
                    setIsAddingDriverAllowed(isAllow);
                } else {
                    setIsAddingDriverAllowed(false);
                }
            }
        }
        function getGroupId(groupHierarchyFlatData, selectedGroup) {
            const _group = groupHierarchyFlatData.find(
                (obj) => obj.id === selectedGroup
            );
            if (_group) {
                expandedNodeId.push(_group.id);
                if (_group.parentGroupId) {
                    getGroupId(groupHierarchyFlatData, _group.parentGroupId);
                }
            }
        }
    }, [selectedGroup, groupHierarchyFlatData]);

    const goBackFunc = () => {
        if (
            history &&
            history.location &&
            history.location.state &&
            history.location.state.from &&
            history.location.state.from === "/admin"
        ) {
            history.replace(`/admin`);
        } else {
            if (userViewAction === CrudAction.EDIT) {
                history.replace(`/admin/users/${userId}`, {
                    from: history.location,
                });
            } else {
                history.goBack();
            }
        }
    };

    function dateToLocaleString(date: string) {
        var d = new Date(date);
        return d.toDateString() + ' ' + d.toLocaleTimeString();
    }

    const [isLicenseAdded, setIsLicenseAdded] = useState(false);
    const [isGetLicenseApi, setIsGetLicenseApi] = useState(false);
    const [isGetLicenseApiFailed, setIsGetLicenseApiFailed] = useState(true);
    const [isLicenseExpired, setIsLicenseExpired] = useState(false);
    const [isLicenseExpiringSoon, setIsLicenseExpiringSoon] = useState(false);

    async function getLicenseData() {
        if (userViewAction !== CrudAction.ADD) {
            const data = await GetUserLicenseAPI(userData.id, UserLicenseView.DEFAULT);
            if (data && (data.status.code === 0 || data.status.code === 200 || data.status.code === 201) && data.content) {
                let driver = userData.userRoles.find(el => el === Role.DRIVER);
                if (driver !== undefined || driver !== null) {
                    if (data.content.licenseList.length) {
                        setLicenseData(data.content);
                        setIsLicenseAdded(true);
                        if (data.content.licenseList[0].expiryDate) {
                            setIsLicenseExpired(new Date(data.content.licenseList[0].expiryDate) < new Date() ? true : false);
                            let expiryPeriod = dateDiffInDays(new Date(), new Date(data.content.licenseList[0].expiryDate));
                            setIsLicenseExpiringSoon(expiryPeriod <= licenseExpireSoonPeriod ? true : false);
                        }
                    } else {
                        setLicenseData({ id: "", licenseList: [] });
                        setIsLicenseAdded(false);
                    }
                } else {
                    setLicenseData({ id: "", licenseList: [] });
                    setIsLicenseAdded(false);
                }
                setIsGetLicenseApi(true);
                setIsGetLicenseApiFailed(false);

                if (props?.location?.state?.licenseDialogOpen) {
                    setLicenseDialogOpen(true);
                    window.history.replaceState(null, '');
                }
            } else {
                setIsGetLicenseApi(false);
                setIsGetLicenseApiFailed(true);
            }
        }
    }

    const licenseDetailsDialogFunc = (isOpen, action) => {
        setLicenseDialogOpen(isOpen);
        if (action) {
            getLicenseData();
        }
    };

    return (
        <>
            <CustomGrid container spacing={4} justifyContent="space-between">
                <CustomGrid item xs={12}>
                    <Breadcrumb
                        currentPage={
                            userViewAction === CrudAction.ADD
                                ? t("ADD_NEW_USER")
                                : userViewAction === CrudAction.EDIT
                                    ? t("EDIT_USER")
                                    : userViewAction === CrudAction.VIEW
                                        ? t("USER_DETAILS")
                                        : null
                        }
                        showAdmin
                    />
                </CustomGrid>
            </CustomGrid>
            {userViewAction !== CrudAction.ADD && isGetUserApi ? (
                <CustomGrid
                    className={classes.userSearchResultWrapper}
                    item
                    xs={12}
                    lg={12}
                >
                    <CustomCircularProgress />
                </CustomGrid>
            ) : (
                <>
                    <CustomPaper square elevation={0} className={classes.adminPage}>
                        <CustomGrid container spacing={4} justifyContent="space-between">
                            <CustomGrid item xs={12} className={classes.adminPageHeader}>
                                <CustomTypography
                                    component="h1"
                                    variant="h5"
                                    className={classes.adminPageTitle}
                                >
                                    <img
                                        src={backButton}
                                        onClick={goBackFunc}
                                        className={classes.goBack}
                                        alt="Back"
                                    />
                                    {userViewAction === CrudAction.ADD
                                        ? t("ADD_NEW_USER")
                                        : userViewAction === CrudAction.EDIT
                                            ? t("EDIT_USER")
                                            : userViewAction === CrudAction.VIEW
                                                ? t("USER_DETAILS")
                                                : null}
                                </CustomTypography>
                                {!isIpadPortraitDown &&
                                    userViewAction === CrudAction.VIEW &&
                                    getRBAC_AdminUserEditView &&
                                    getRBAC_AdminUserEditView.isAccessible ===
                                    EntityAccess.ALLOWED &&
                                    (getRBAC_AdminUserEditView.isGroupScope ===
                                        EntityAccess.ALLOWED ||
                                        (loggedInUserData && loggedInUserData.id === userId)) ? (
                                    <CustomButton
                                        variant="contained"
                                        color="primary"
                                        onClick={() =>
                                            history.replace(`/admin/users/edit/${userId}`, {
                                                from: history.location,
                                            })
                                        }
                                        // href={`/admin/users/edit/${userId}`}
                                        className={classes.primaryButtonXl}
                                        defaultrounded="true"
                                    >
                                        {t("EDIT_USER")}
                                    </CustomButton>
                                ) : null}
                            </CustomGrid>
                            {userViewAction ? (
                                <>
                                    {userViewAction !== CrudAction.ADD && isDriver && !isAddingDriverAllowed ? (
                                        <CustomGrid item xs={12}>
                                            <CustomTypography
                                                component="h6"
                                                variant="h6"
                                                className={classes.adminPageInfo}
                                            >
                                                <img
                                                    src={plugIcon}
                                                    className={classes.adminPageInfoIcon}
                                                    alt="Back"
                                                />
                                                {t(
                                                    "THIS_USER_IS_MANAGED_BY_INTEGRATION_WITH_TELEMATICS"
                                                )}
                                            </CustomTypography>
                                        </CustomGrid>
                                    ) : null}
                                </>
                            ) : null}
                            <CustomGrid item xs={12} lg={5}>
                                <CustomBox className={classes.formGroup}>
                                    <CustomTypography
                                        component="h1"
                                        variant="h5"
                                        className={classes.formGroupLabel}
                                    >
                                        {t("PERSONAL_INFORMATION")}
                                    </CustomTypography>
                                    <CustomTextField
                                        disabled={userViewAction === CrudAction.VIEW || !isNameEdit}
                                        className={classes.adminInput}
                                        fullWidth
                                        id="fname"
                                        type="text"
                                        label={`${t("FIRST_NAME")} *`}
                                        value={userData.firstName}
                                        onChange={(e) =>
                                            setUserData({
                                                ...userData,
                                                firstName: e.target.value,
                                            })
                                        }
                                        InputLabelProps={{ shrink: true }}
                                        inputRef={input => {
                                            if (input && !userFormValidation["firstName"].isValid && isFormSubmit && setFocus.current) {
                                                setFocus.current = false;
                                                input.focus();
                                                window.scrollTo({ top: fnamePosition, behavior: 'smooth' });
                                            }
                                        }}
                                        InputProps={{
                                            disableUnderline: true,
                                        }}
                                        error={
                                            userFormValidation["firstName"].isValid ? false : true
                                        }
                                        helperText={
                                            userFormValidation["firstName"].validationMessage
                                        }
                                    />
                                    <CustomTextField
                                        disabled={userViewAction === CrudAction.VIEW || !isNameEdit}
                                        className={classes.adminInput}
                                        fullWidth
                                        type="text"
                                        label={t("MIDDLE_NAME")}
                                        value={userData.middleName === null ? "" : userData.middleName}
                                        onChange={(e) =>
                                            setUserData({
                                                ...userData,
                                                middleName: e.target.value,
                                            })
                                        }
                                        InputLabelProps={{ shrink: true }}
                                        InputProps={{
                                            disableUnderline: true,
                                        }}
                                    />
                                    <CustomTextField
                                        disabled={userViewAction === CrudAction.VIEW || !isNameEdit}
                                        className={classes.adminInput}
                                        fullWidth
                                        id="lname"
                                        type="text"
                                        label={`${t("LAST_NAME")} *`}
                                        value={userData.lastName}
                                        onChange={(e) =>
                                            setUserData({
                                                ...userData,
                                                lastName: e.target.value,
                                            })
                                        }
                                        InputLabelProps={{ shrink: true }}
                                        inputRef={input => {
                                            if (input && !userFormValidation["lastName"].isValid && isFormSubmit && setFocus.current) {
                                                input.focus();
                                                setFocus.current = false;
                                                window.scrollTo({ top: lnamePosition, behavior: 'smooth' });
                                            }
                                        }}
                                        InputProps={{
                                            disableUnderline: true,
                                        }}
                                        error={
                                            userFormValidation["lastName"].isValid ? false : true
                                        }
                                        helperText={
                                            userFormValidation["lastName"].validationMessage
                                        }
                                    />
                                    <CustomTextField
                                        disabled={userViewAction === CrudAction.VIEW}
                                        className={classes.adminInput}
                                        fullWidth
                                        type="email"
                                        id="email"
                                        label={`${t("EMAIL")} *`}
                                        value={userData.email}
                                        onChange={(e) =>
                                            setUserData({
                                                ...userData,
                                                email: e.target.value,
                                            })
                                        }
                                        InputLabelProps={{ shrink: true }}
                                        inputRef={input => {
                                            if (input && !userFormValidation["email"].isValid && isFormSubmit && setFocus.current) {
                                                input.focus();
                                                setFocus.current = false;
                                                window.scrollTo({ top: emailPosition, behavior: 'smooth' });
                                            }
                                        }}
                                        InputProps={{
                                            disableUnderline: true,
                                        }}
                                        error={userFormValidation["email"].isValid ? false : true}
                                        helperText={userFormValidation["email"].validationMessage}
                                    />
                                    {userData.isAnonymize === 1 && userData.userRoleId === 6 ? <CustomTextField
                                        disabled={userViewAction === CrudAction.VIEW}
                                        className={classes.adminInput}
                                        fullWidth
                                        type="text"
                                        id="nickName"
                                        label={`${t("NICKNAME")} *`}
                                        value={userData.nickName}
                                        onChange={(e) =>
                                            setUserData({
                                                ...userData,
                                                nickName: e.target.value,
                                            })
                                        }
                                        InputLabelProps={{ shrink: true }}
                                        inputRef={input => {
                                            if (input && !userFormValidation["nickName"].isValid && isFormSubmit && setFocus.current) {
                                                input.focus();
                                                setFocus.current = false;
                                                window.scrollTo({ top: nickNamePosition, behavior: 'smooth' });
                                            }
                                        }}
                                        InputProps={{
                                            disableUnderline: true,
                                        }}
                                        error={
                                            userFormValidation["nickName"].isValid ? false : true
                                        }
                                        helperText={
                                            userFormValidation["nickName"].validationMessage
                                        }
                                    /> : null}
                                </CustomBox>
                                <CustomBox className={classes.formGroup}>
                                    <CustomTypography
                                        component="h1"
                                        variant="h5"
                                        className={classes.formGroupLabel}
                                    >
                                        {t("GROUP_INFORMATION")}
                                    </CustomTypography>
                                    <CustomFormControl
                                        disabled={
                                            userViewAction === CrudAction.VIEW ||
                                            userData.allowChangesToGroupOrgChart === 1
                                        }
                                        fullWidth
                                        className={classes.adminInput}
                                    >
                                        <CustomInputLabel
                                            className={classes.labelWithLoader}
                                            shrink
                                            id="selectGroupLabel"
                                        >
                                            {t("SELECT_GROUP")}{" "}
                                            {!selectedGroup && !groupHierarchyFlatData && (
                                                <CustomCircularProgress
                                                    className={classes.circularProgressSmall}
                                                />
                                            )}
                                        </CustomInputLabel>
                                        {groupHierarchyFlatData &&
                                            groupHierarchyFlatData.length &&
                                            selectedGroup ? (
                                            <CustomSelect
                                                labelId="selectGroupLabel"
                                                disableUnderline
                                                value={selectedGroup}
                                                onChange={(e) => handleGroupChange(e)}
                                            >
                                                {groupHierarchyFlatData.map((item, index) => {
                                                    return (
                                                        <CustomMenuItem
                                                            key={`${index}-group-${item.id}`}
                                                            value={item.id}
                                                        >
                                                            {item.name}
                                                        </CustomMenuItem>
                                                    );
                                                })}
                                            </CustomSelect>
                                        ) : null}
                                    </CustomFormControl>
                                </CustomBox>
                                <CustomBox className={classes.formGroup}>
                                    <CustomTypography
                                        component="h1"
                                        variant="h5"
                                        className={classes.formGroupLabel}
                                    >
                                        {t("USER_ROLE")}
                                    </CustomTypography>
                                    <CustomInputLabel className={classes.labelWithLoader}>
                                        {t("SELECT_ROLE")}
                                        {isUserRoleApi && (
                                            <CustomCircularProgress
                                                className={classes.circularProgressSmall}
                                            />
                                        )}
                                    </CustomInputLabel>
                                    <CustomBox className={classes.userRoleCheckboxWrapper}>
                                        {isUserRoleObj &&
                                            userData.userRoleObj &&
                                            userData.userRoleObj.length
                                            ? userData.userRoleObj.map((item, index) => {
                                                return (
                                                    <CustomBox
                                                        key={`${index}-userRole-${item.roleId}`}
                                                        className={clsx(
                                                            classes.userRoleCheckboxInner,
                                                            item.isSelected
                                                                ? classes.userRoleCheckboxInnerSelected
                                                                : null,
                                                            !isAddingDriverAllowed && !item.isEnabled
                                                                ? classes.userRoleCheckboxInnerDisabled
                                                                : null
                                                        )}
                                                    >
                                                        {item && item.name ? (
                                                            <CustomTypography
                                                                className={classes.userRoleCheckboxTitle}
                                                            >
                                                                <CustomCheckbox
                                                                    value={item.id ? item.id : ""}
                                                                    disabled={
                                                                        (!isAddingDriverAllowed && !item.isEnabled) ||
                                                                        userViewAction === CrudAction.VIEW
                                                                    }
                                                                    checked={item.isSelected}
                                                                    name={`userRole_${index}_${item.id}`}
                                                                    onChange={(e) =>
                                                                        handleUserRoleChange(e, index, item.id)
                                                                    }
                                                                    color="primary"
                                                                    className={classes.userRoleCheckbox}
                                                                    inputProps={{
                                                                        "aria-label": "user role checkbox",
                                                                    }}
                                                                />
                                                                {/* {item.name} */}
                                                                <Trans i18nKey={`ROLE_TITLE_${item.name}`}>
                                                                    {item.name}
                                                                </Trans>
                                                            </CustomTypography>
                                                        ) : null}
                                                        {item && item.description ? (
                                                            <CustomTypography
                                                                className={classes.userRoleCheckboxDesc}
                                                            >
                                                                <Trans
                                                                    i18nKey={`ROLE_DESCRIPTION_${item.name}`}
                                                                >
                                                                    {item.description}
                                                                </Trans>
                                                                {/* {item.description} */}
                                                            </CustomTypography>
                                                        ) : null}
                                                    </CustomBox>
                                                );
                                            })
                                            : null}
                                    </CustomBox>
                                    {/* {userFormValidation &&
                                    userFormValidation["userRoles"].isRequired &&
                                    !userFormValidation["userRoles"].isValid ? (
                                        <CustomTypography className="MuiFormHelperText-root Mui-error">
                                        {userFormValidation["userRoles"].validationMessage}
                                        </CustomTypography>
                                    ) : null} */}
                                </CustomBox>
                                {userViewAction !== CrudAction.ADD && isLicenseAdd && isDriver ?
                                    <>
                                        <CustomBox className={classes.licenseGroup}>
                                            <CustomTypography
                                                component="h1"
                                                variant="h5"
                                                className={classes.licenceLabel}
                                            >
                                                {t("LICENSES")}
                                            </CustomTypography>
                                            {isLicenseAdded && isGetLicenseApi ?
                                                <CustomTypography
                                                    component="h1"
                                                    variant="h5"
                                                    className={classes.viewAllLabel}
                                                    onClick={() => licenseDetailsDialogFunc(true, false)}
                                                >
                                                    {t("VIEW_ALL")}
                                                </CustomTypography>
                                                : null}
                                            {!isLicenseAdded && isGetLicenseApi ?
                                                <CustomBox className={classes.addLicense}
                                                    onClick={() => licenseDetailsDialogFunc(true, false)}
                                                >
                                                    <AddIcon style={{ fontSize: 30 }} />
                                                    <CustomTypography
                                                        component="h1"
                                                        variant="h5"
                                                        className={classes.addLicenceLabel}
                                                    >
                                                        {t("ADD_LICENSE")}
                                                    </CustomTypography>
                                                </CustomBox>
                                                : null}
                                            {licenseDialogOpen ? (
                                                <LicenseDetailsDialog
                                                    dialogOpen={licenseDialogOpen}
                                                    dialogClose={(isOpen, confirmDelete) =>
                                                        licenseDetailsDialogFunc(isOpen, confirmDelete)
                                                    }
                                                    isLicenseAdded={isLicenseAdded}
                                                    setIsLicenseAdded={setIsLicenseAdded}
                                                    userId={userData.id}
                                                    getLicenseData={getLicenseData}
                                                />
                                            ) : null}
                                        </CustomBox>
                                        {isGetLicenseApi && !isGetLicenseApiFailed && licenseData.licenseList.length ?
                                            <CustomBox className={classes.licenceDetailsCard}>
                                                <CustomBox className={classes.licenceDetailsWrapper}>
                                                    <CustomBox className={classes.licenseNoBlock}>
                                                        <CustomTypography
                                                            component="h1"
                                                            variant="h5"
                                                            className={classes.licenceHead}
                                                        >
                                                            {t("LICENSE_NO")}
                                                        </CustomTypography>
                                                        {licenseData?.licenseList[0]?.isDefault ?
                                                            <CustomTypography
                                                                className={classes.tag}
                                                            >
                                                                {t("DEFAULT")}
                                                            </CustomTypography>
                                                            : null}
                                                        {isLicenseExpired ?
                                                            <CustomTypography className={classes.expiryTag} >
                                                                {t("EXPIRED")}
                                                            </CustomTypography> :
                                                            isLicenseExpiringSoon ?
                                                                <CustomTypography className={classes.expiryTag} >
                                                                    {t("EXPIRING_SOON")}
                                                                </CustomTypography> :
                                                                null
                                                        }
                                                        <CustomTypography
                                                            component="h1"
                                                            variant="h5"
                                                            className={classes.licenceNumberText}
                                                        >
                                                            {licenseData?.licenseList[0]?.licenseNo}
                                                        </CustomTypography>
                                                    </CustomBox>
                                                    <CustomBox className={classes.licenceExpiry}>
                                                        <CustomTypography
                                                            component="h1"
                                                            variant="h5"
                                                            className={classes.licenceHead}
                                                        >
                                                            {t("EXPIRY_DATE")}
                                                        </CustomTypography>
                                                        <CustomBox style={{ display: 'flex' }} className={classes.licenceContent}>
                                                            {licenseData?.licenseList[0]?.expiryDate !== undefined && licenseData?.licenseList[0]?.expiryDate !== null && licenseData?.licenseList[0]?.expiryDate.length > 0 ? (
                                                                <>
                                                                    <DateTime
                                                                        inputDate={licenseData?.licenseList[0]?.expiryDate}
                                                                        returnFormat="DD MMM"
                                                                    />
                                                                    ,<div style={{ marginLeft: '.25rem' }}></div>
                                                                    <DateTime
                                                                        inputDate={licenseData?.licenseList[0]?.expiryDate}
                                                                        returnFormat="YYYY"
                                                                    />
                                                                </>
                                                            ) : "-"
                                                            }

                                                        </CustomBox>
                                                    </CustomBox>
                                                    <CustomBox className={classes.licenceExpiry}>
                                                        <CustomTypography
                                                            component="h1"
                                                            variant="h5"
                                                            className={classes.licenceHead}
                                                        >
                                                            {t("POINTS")}
                                                        </CustomTypography>
                                                        <CustomTypography
                                                            component="h1"
                                                            variant="h5"
                                                            className={classes.licenceContent}
                                                        >
                                                            {licenseData?.licenseList[0]?.points >= 0 ? licenseData.licenseList[0].points : "-"}
                                                        </CustomTypography>
                                                    </CustomBox>
                                                </CustomBox>
                                            </CustomBox> : null}
                                    </> : null}
                                {/* <CustomBox className={classes.validateLicenceWrapper}>
                                    <CustomTypography
                                        component="h1"
                                        variant="h5"
                                        className={classes.validateLicenceLabel}
                                    >
                                        {'Validate License'}
                                    </CustomTypography>
                                    <CustomBox className={classes.validateLicenceInnerWrapper}>
                                        <CustomTextField
                                            disabled={userViewAction === CrudAction.VIEW}
                                            className={classes.adminInput}
                                            fullWidth
                                            type="license"
                                            label={`${t("License No")} *`}
                                            value={licenseNumber}
                                            onChange={(e) =>
                                                setLicenseNumber(e.target.value)
                                            }
                                            InputLabelProps={{ shrink: true }}
                                            InputProps={{
                                                disableUnderline: true,
                                            }}
                                        />
                                        <CustomButton
                                            variant="contained"
                                            color="primary"
                                            disabled={isUpsertUserApi}
                                            onClick={() => validateLicenseNumber()}
                                            className={classes.validateLicenceButton}
                                            defaultrounded="true"
                                        >
                                            {userViewAction === CrudAction.ADD
                                                ? t("Validate")
                                                : t("")}
                                            {isUpsertUserApi && crudAction !== CrudAction.DELETE && (
                                                <>
                                                    {" "}
                                                    <CustomCircularProgress
                                                        className={classes.circularProgressSmall}
                                                    />
                                                </>
                                            )}
                                        </CustomButton>
                                    </CustomBox>
                                </CustomBox> */}
                            </CustomGrid>
                            <CustomGrid item xs={12} lg={4}>
                                {userViewAction !== CrudAction.ADD ?
                                    <CustomBox className={classes.formGroup}>
                                        <CustomBox className={clsx(accountLocked === IsUserAccountLocked.UNLOCKED ? classes.unlockPageCard : classes.unlockUserCard,)}>
                                            <CustomBox className={clsx(classes.iconTextCard)} >
                                                <img
                                                    src={lock}
                                                    className={classes.lockIcon}
                                                    alt="lock"
                                                />
                                                <CustomTypography
                                                    component="h1"
                                                    variant="h5"
                                                    className={clsx(
                                                        classes.unlockUserLabel,
                                                        accountLocked === IsUserAccountLocked.UNLOCKED ? classes.lockUserLabel : null
                                                    )}
                                                >
                                                    {accountLocked === IsUserAccountLocked.UNLOCKED ?
                                                        t("LOCK_THIS_USER_FOR_NOT_USING_ANY_PRAISO_SERVICES")
                                                        : t("THIS_USER_IS_LOCKED_AND_NOT_USING_ANY_PRAISO_SERVICES")}
                                                </CustomTypography>
                                            </CustomBox>
                                            <CustomBox className={clsx(classes.unlockButtonCard)} >
                                                <CustomButton
                                                    variant="contained"
                                                    color="primary"
                                                    //disabled={null}
                                                    onClick={() => unlockUserDialogFunc(true, false)}
                                                    className={classes.unlockButtonXl}
                                                    defaultrounded="true"
                                                >
                                                    {accountLocked === IsUserAccountLocked.LOCKED
                                                        ? t("UNLOCK_USER")
                                                        : t("LOCK_USER")}
                                                    {isUpsertUserApi && crudAction !== CrudAction.DELETE && (
                                                        <>
                                                            {" "}
                                                            <CustomCircularProgress
                                                                className={classes.circularProgressSmall}
                                                            />
                                                        </>
                                                    )}
                                                </CustomButton>
                                                {unlockDialogOpen ? (
                                                    <>
                                                        <UnlockUserDialog
                                                            dialogOpen={unlockDialogOpen}
                                                            dialogClose={(isOpen, confirmUnlock) =>
                                                                unlockUserDialogFunc(isOpen, confirmUnlock)
                                                            }
                                                            userName={{
                                                                firstName: userData.firstName,
                                                                middleName: userData.middleName,
                                                                lastName: userData.lastName,
                                                            }}
                                                            isAccountLocked={accountLocked}
                                                        />
                                                    </>
                                                ) : null}
                                            </CustomBox>
                                        </CustomBox>
                                    </CustomBox>
                                    : null}
                                <CustomBox className={classes.formGroup}>
                                    <CustomTypography
                                        component="h1"
                                        variant="h5"
                                        className={classes.formGroupLabel}
                                    >
                                        {t("HIERARCHY_PREVIEW")}
                                    </CustomTypography>
                                    <CustomBox className={classes.adminPageCard}>
                                        {selectedGroup ? (
                                            <GroupHierarchy
                                                setGroupHierarchyData={(groupHierarchy) =>
                                                    setGroupHierarchyData(groupHierarchy)
                                                }
                                                selectionDisabled={
                                                    userViewAction === CrudAction.VIEW ||
                                                        userData.allowChangesToGroupOrgChart === 1 ||
                                                        isDriver
                                                        ? true
                                                        : false
                                                }
                                                defaultExpanded={[...defaultExpandedArray]}
                                                defaultSelected={selectedGroup}
                                                onHierarchySelectionChange={(e) => handleGroupChange(e)}
                                            />
                                        ) : null}
                                    </CustomBox>
                                </CustomBox>
                                {userViewAction !== CrudAction.ADD && userData.userRoles ? (
                                    <>
                                        {userData.userRoles.find((id) => id === Role.DRIVER) && (
                                            <CustomBox className={classes.formGroup}>
                                                <CustomTypography
                                                    component="h1"
                                                    variant="h5"
                                                    className={classes.formGroupLabel}
                                                >
                                                    {t("CONTENT_STATUS")}
                                                </CustomTypography>
                                                <CustomBox className={classes.adminPageCard}>
                                                    <CustomList component="ul">
                                                        <CustomListItem
                                                            className={classes.adminPageCardListitem}
                                                        >
                                                            <CustomFormControl fullWidth component="fieldset">
                                                                <CustomRadioGroup
                                                                    disabled={
                                                                        userViewAction === CrudAction.VIEW ||
                                                                        userData.status < 0
                                                                    }
                                                                    row
                                                                    aria-label="contentStatus"
                                                                    name="contentStatus"
                                                                    value={
                                                                        userData.status === ContentStatus.NA
                                                                            ? ContentStatus.ONHOLD.toString()
                                                                            : userData.status.toString()
                                                                    }
                                                                    onChange={(e) => changeContentStatus(e)}
                                                                >
                                                                    <CustomBox
                                                                        flexGrow={1}
                                                                        className={classes.customRadioWrapper}
                                                                    >
                                                                        <CustomFormControlLabel
                                                                            value={`${ContentStatus.ACTIVE}`}
                                                                            control={
                                                                                <CustomRadio
                                                                                    disabled={
                                                                                        userViewAction === CrudAction.VIEW
                                                                                    }
                                                                                    color="primary"
                                                                                />
                                                                            }
                                                                            label={t("ACTIVE")}
                                                                        />
                                                                    </CustomBox>
                                                                    <CustomBox
                                                                        flexGrow={1}
                                                                        className={classes.customRadioWrapper}
                                                                    >
                                                                        <CustomFormControlLabel
                                                                            value={`${ContentStatus.ONHOLD}`}
                                                                            control={
                                                                                <CustomRadio
                                                                                    disabled={
                                                                                        userViewAction === CrudAction.VIEW
                                                                                    }
                                                                                    color="primary"
                                                                                />
                                                                            }
                                                                            label={t("ON_HOLD")}
                                                                        />
                                                                    </CustomBox>
                                                                </CustomRadioGroup>
                                                            </CustomFormControl>
                                                        </CustomListItem>
                                                    </CustomList>
                                                </CustomBox>
                                            </CustomBox>
                                        )}
                                        <CustomBox className={classes.formGroup}>
                                            <CustomTypography
                                                component="h1"
                                                variant="h5"
                                                className={classes.formGroupLabel}
                                            >
                                                {t("OTHER_INFO")}
                                            </CustomTypography>
                                            <CustomBox className={classes.adminPageCard}>
                                                <CustomList component="ul">
                                                    <CustomListItem
                                                        className={classes.adminPageCardListitem}
                                                    >
                                                        <CustomBox className={classes.adminPageCardLabel}>
                                                            {t("ADDED_ON")}
                                                        </CustomBox>
                                                        <CustomBox className={classes.adminPageCardValue}>
                                                            <DateTime
                                                                inputDate={userData.createdOn}
                                                                returnFormat="ddd"
                                                            />{" "}
                                                            -{" "}
                                                            <DateTime
                                                                inputDate={userData.createdOn}
                                                                returnFormat="DD MMM"
                                                            />
                                                            ,{" "}
                                                            <DateTime
                                                                inputDate={userData.createdOn}
                                                                returnFormat="YYYY"
                                                            />{" "}
                                                            |{" "}
                                                            <DateTime
                                                                inputDate={userData.createdOn}
                                                                returnFormat="hh:mm a"
                                                            />
                                                        </CustomBox>
                                                    </CustomListItem>
                                                    <CustomListItem
                                                        className={classes.adminPageCardListitem}
                                                    >
                                                        <CustomDivider className={classes.spacer} />
                                                    </CustomListItem>
                                                    <CustomListItem
                                                        className={classes.adminPageCardListitem}
                                                    >
                                                        <CustomBox className={classes.adminPageCardLabel}>
                                                            {t("STATUS")}
                                                        </CustomBox>
                                                        <CustomBox className={classes.adminPageCardValue}>
                                                            <Trans
                                                                i18nKey={`USER_STATUS_${Object.keys(
                                                                    RecordStatus
                                                                ).find(
                                                                    (key) =>
                                                                        RecordStatus[key] === userData.recordStatus
                                                                )}`}
                                                            >
                                                                {Object.keys(RecordStatus).find(
                                                                    (key) =>
                                                                        RecordStatus[key] === userData.recordStatus
                                                                )}
                                                            </Trans>
                                                        </CustomBox>
                                                    </CustomListItem>
                                                    <CustomListItem
                                                        className={classes.adminPageCardListitem}
                                                    >
                                                        <CustomDivider className={classes.spacer} />
                                                    </CustomListItem>
                                                    <CustomListItem
                                                        className={classes.adminPageCardListitem}
                                                    >
                                                        <CustomBox className={classes.adminPageCardLabel}>
                                                            {t("TELEMENTRY_ID")}
                                                        </CustomBox>
                                                        <CustomBox className={classes.adminPageCardValue}>
                                                            {userData.providerUserInfo &&
                                                                userData.providerUserInfo.providerUserNo
                                                                ? userData.providerUserInfo.providerUserNo
                                                                : "N/A"}
                                                        </CustomBox>
                                                    </CustomListItem>
                                                    <CustomListItem
                                                        className={classes.adminPageCardListitem}
                                                    >
                                                        <CustomDivider className={classes.spacer} />
                                                    </CustomListItem>
                                                    <CustomListItem
                                                        className={classes.adminPageCardListitem}
                                                    >
                                                        <CustomBox className={classes.adminPageCardLabel}>
                                                            {t("UUID")}
                                                        </CustomBox>
                                                        <CustomBox className={classes.adminPageCardValue}>
                                                            {userData.providerUserInfo &&
                                                                userData.providerUserInfo.providerUserUid
                                                                ? userData.providerUserInfo.providerUserUid
                                                                : "N/A"}
                                                        </CustomBox>
                                                    </CustomListItem>
                                                    <CustomListItem
                                                        className={classes.adminPageCardListitem}
                                                    >
                                                        <CustomDivider className={classes.spacer} />
                                                    </CustomListItem>
                                                    <CustomListItem
                                                        className={classes.adminPageCardListitem}
                                                    >
                                                        <CustomBox className={classes.adminPageCardLabel}>
                                                            <CustomButton
                                                                disabled={isResetPasswordApi}
                                                                onClick={() =>
                                                                    resetPasswordFunc(userData.email)
                                                                }
                                                                className={classes.adminPageCardLink}
                                                            >
                                                                {t("SEND_RESET_PASSWORD_LINK")}
                                                                {isResetPasswordApi && (
                                                                    <CustomCircularProgress
                                                                        className={classes.circularProgressSmall}
                                                                    />
                                                                )}
                                                            </CustomButton>
                                                        </CustomBox>
                                                        {(!isDriver || isAllowDeleteDriver) && (userViewAction !== CrudAction.ADD &&
                                                            getRBAC_AdminUserDeleteView &&
                                                            getRBAC_AdminUserDeleteView.isGroupScope ===
                                                            EntityAccess.ALLOWED &&
                                                            getRBAC_AdminUserDeleteView.isAccessible ===
                                                            EntityAccess.ALLOWED) ? (
                                                            <CustomButton
                                                                disabled={isUpsertUserApi}
                                                                variant="outlined"
                                                                color="secondary"
                                                                onClick={() =>
                                                                    deleteUserDialogFunc(true, false)
                                                                }
                                                                className={clsx(
                                                                    classes.secondaryOutlinedButton
                                                                )}
                                                                defaultrounded="true"
                                                            >
                                                                {t("DELETE_USER")}
                                                                {isUpsertUserApi &&
                                                                    crudAction === CrudAction.DELETE && (
                                                                        <>
                                                                            {" "}
                                                                            <CustomCircularProgress
                                                                                color="secondary"
                                                                                className={
                                                                                    classes.circularProgressSmall
                                                                                }
                                                                            />
                                                                        </>
                                                                    )}
                                                            </CustomButton>
                                                        ) : null}
                                                        {/* {userData.userRoles && userData.userRoles.length && (
                                                        <>
                                                            {userData.userRoles.find(
                                                            (id) => id === Role.DRIVER
                                                            ) ? null : (
                                                            <CustomButton
                                                                disabled={isUpsertUserApi}
                                                                variant="outlined"
                                                                color="secondary"
                                                                onClick={() =>
                                                                deleteUserDialogFunc(true, false)
                                                                }
                                                                className={clsx(
                                                                classes.secondaryOutlinedButton
                                                                )}
                                                                defaultrounded
                                                            >
                                                                Delete User
                                                                {isUpsertUserApi && (
                                                                <CustomCircularProgress
                                                                    color="secondary"
                                                                    className={
                                                                    classes.circularProgressSmall
                                                                    }
                                                                />
                                                                )}
                                                            </CustomButton>
                                                            )}
                                                        </>
                                                        )} */}
                                                    </CustomListItem>
                                                </CustomList>
                                            </CustomBox>
                                        </CustomBox>
                                    </>
                                ) : null}
                            </CustomGrid>
                            <CustomGrid item xs={12} lg={12}>
                                {userViewAction !== CrudAction.VIEW &&
                                    ((getRBAC_AdminUserEditView &&
                                        getRBAC_AdminUserEditView.isAccessible ===
                                        EntityAccess.ALLOWED &&
                                        (getRBAC_AdminUserEditView.isGroupScope ===
                                            EntityAccess.ALLOWED ||
                                            (loggedInUserData && loggedInUserData.id === userId))) ||
                                        (getRBAC_AdminUserCreateView &&
                                            getRBAC_AdminUserCreateView.isGroupScope ===
                                            EntityAccess.ALLOWED &&
                                            getRBAC_AdminUserCreateView.isAccessible ===
                                            EntityAccess.ALLOWED)) ? (
                                    <CustomButton
                                        variant="contained"
                                        color="primary"
                                        disabled={isUpsertUserApi}
                                        onClick={() => verifyUserInput(userData)}
                                        className={classes.primaryButtonXl}
                                        defaultrounded="true"
                                    >
                                        {userViewAction === CrudAction.ADD
                                            ? t("ADD_USER")
                                            : t("UPDATE_USER")}
                                        {isUpsertUserApi && crudAction !== CrudAction.DELETE && (
                                            <>
                                                {" "}
                                                <CustomCircularProgress
                                                    className={classes.circularProgressSmall}
                                                />
                                            </>
                                        )}
                                    </CustomButton>
                                ) : null}
                                {isIpadPortraitDown &&
                                    userViewAction === CrudAction.VIEW &&
                                    getRBAC_AdminUserEditView &&
                                    getRBAC_AdminUserEditView.isAccessible ===
                                    EntityAccess.ALLOWED &&
                                    (getRBAC_AdminUserEditView.isGroupScope ===
                                        EntityAccess.ALLOWED ||
                                        (loggedInUserData && loggedInUserData.id === userId)) ? (
                                    <CustomButton
                                        variant="contained"
                                        color="primary"
                                        onClick={() =>
                                            history.replace(`/admin/users/edit/${userId}`, {
                                                from: history.location,
                                            })
                                        }
                                        // href={`/admin/users/edit/${userId}`}
                                        className={classes.primaryButtonXl}
                                        defaultrounded="true"
                                    >
                                        {t("EDIT_USER")}
                                    </CustomButton>
                                ) : null}
                            </CustomGrid>
                        </CustomGrid>
                    </CustomPaper>
                    {userViewAction !== CrudAction.DELETE && deleteDialogOpen ? (
                        <>
                            <DeleteUserDialog
                                dialogOpen={deleteDialogOpen}
                                dialogClose={(isOpen, confirmDelete) =>
                                    deleteUserDialogFunc(isOpen, confirmDelete)
                                }
                                userName={{
                                    firstName: userData.firstName,
                                    middleName: userData.middleName,
                                    lastName: userData.lastName,
                                }}
                            />
                        </>
                    ) : null}
                </>
            )}
            <ErrorAlert
                code={resetPasswordStatusValue}
                message={resetPasswordAlertMessage}
                description={resetPasswordAlertDescription}
                isOpen={isResetPasswordAlertOpen}
                alertType={resetPasswordAlertType}
                isClose={(isClose) => setIsResetPasswordAlertOpen(!isClose)}
            />
            <ErrorAlert
                code={upsertUserStatusValue}
                message={upsertUserAlertMessage}
                description={upsertUserAlertDescription}
                isOpen={isUpsertUserAlertOpen}
                alertType={upsertUserAlertType}
                isClose={(isClose) => setIsUpsertUserAlertOpen(!isClose)}
            />
            <ErrorAlert
                code={getUserStatusValue}
                message={getUserAlertMessage}
                isOpen={isGetUserAlertOpen}
                isClose={(isClose) => setIsGetUserAlertOpen(!isClose)}
            />
            <ErrorAlert
                code={userRoleStatusValue}
                message={userRoleAlertMessage}
                isOpen={isUserRoleAlertOpen}
                isClose={(isClose) => setIsUserRoleAlertOpen(!isClose)}
            />
        </>
    );
}
